/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DeepAnalysisControllerStreamQueryResponse, DeepAnalysisControllerStreamPathParams, DeepAnalysisControllerStream401, DeepAnalysisControllerStream403 } from "../../models/aiAgentV2Controller/DeepAnalysisControllerStream";

function getDeepAnalysisControllerStreamUrl(sessionId: DeepAnalysisControllerStreamPathParams["sessionId"]) {
  const res = { method: 'GET', url: `/api/v1/ai-agent-v2/deep-analysis/${sessionId}/stream` as const }  
  return res
}

/**
 * @summary Stream deep analysis events via SSE
 * {@link /api/v1/ai-agent-v2/deep-analysis/:sessionId/stream}
 */
export async function deepAnalysisControllerStream(sessionId: DeepAnalysisControllerStreamPathParams["sessionId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeepAnalysisControllerStreamQueryResponse, ResponseErrorConfig<DeepAnalysisControllerStream401 | DeepAnalysisControllerStream403>, unknown>({ method : "GET", url : getDeepAnalysisControllerStreamUrl(sessionId).url.toString(), ... requestConfig })  
  return res.data
}